import './styles.scss'
import PropTypes from 'prop-types'

const Input = (props) => {
  const classNames = ['InputText']
  let label
  if (props.label !== undefined) {
    label = <label>{props.label + (props.required ? ' *' : '')}</label>
  }

  let message
  if (props.valid !== true) {
    if (props.message) {
      message = <span>{props.message}</span>
    }
    classNames.push('InputTextError')
  }

  return (
    <div className={classNames.join(' ')}>
      {label} {message}
      <input type={props.type}
             placeholder={props.placeholder}
             disabled={props.disabled}
             required={props.required}
             onChange={props.onChange}
             onBlur={props.onBlur}
             value={props.value}/>
    </div>
  )
}

Input.defaultProps = {
  type: 'text',
  placeholder: '',
  disabled: false,
  required: false,
  valid: true,
}

Input.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  valid: PropTypes.bool,
  message: PropTypes.string,
}

export default Input
